import { z } from "zod";
const SCOPE_IDS = [
    "vendors:read",
    "vendors:write",
    "price_books:read",
    "price_books:write",
    "invoices:read",
    "invoices:write",
    "picklists:read",
    "picklists:write",
    "config:read",
];
export const Scope = {
    VENDORS_READ: "vendors:read",
    VENDORS_WRITE: "vendors:write",
    PRICE_BOOKS_READ: "price_books:read",
    PRICE_BOOKS_WRITE: "price_books:write",
    INVOICES_READ: "invoices:read",
    INVOICES_WRITE: "invoices:write",
    PICKLISTS_READ: "picklists:read",
    PICKLISTS_WRITE: "picklists:write",
    CONFIG_READ: "config:read",
};
export const API_SCOPES = [
    { id: Scope.VENDORS_READ, label: "Read Vendors" },
    { id: Scope.VENDORS_WRITE, label: "Write Vendors" },
    { id: Scope.PRICE_BOOKS_READ, label: "Read Price Books" },
    { id: Scope.PRICE_BOOKS_WRITE, label: "Write Price Books" },
    { id: Scope.INVOICES_READ, label: "Read Invoices" },
    { id: Scope.INVOICES_WRITE, label: "Write Invoices" },
    { id: Scope.PICKLISTS_READ, label: "Read Picklists" },
    { id: Scope.PICKLISTS_WRITE, label: "Write Picklists" },
    { id: Scope.CONFIG_READ, label: "Read Configuration" },
];
export const apiScopeSchema = z.enum(SCOPE_IDS);
//# sourceMappingURL=scopes.js.map